import { getAggregatedTranslations, addMissingTranslation } from '@/services/ws-translate/src/main/resources/rest-api/index.ts';
import { StatusSchema, unsafeCastToApiError } from '@/js/libs/api/index.ts';
const missingTranslationShouldBeAdded = (translation) => !!(translation.key && translation.key.match(/^[A-Z0-9-_]+$/));
const backendOptions = {
    loadPath: '{{lng}}.{{ns}}',
    addPath: '{{lng}}.{{ns}}',
    request: (options, url, payload, callback) => {
        const [lng, ns = ''] = url.split('.');
        if (payload) {
            const [key = ''] = Object.keys(payload);
            const pageRef = window.location.pathname;
            const translation = {
                namespace: ns,
                key,
                pageRef,
            };
            if (missingTranslationShouldBeAdded(translation)) {
                addMissingTranslation({ params: { translation } })
                    .then(({ status }) => {
                    const response = {
                        status,
                        data: '',
                    };
                    callback(null, response);
                })
                    .catch((error) => callback(error, { status: unsafeCastToApiError(error, StatusSchema)?.response?.status || 500, data: '' }));
            }
            else {
                callback(null, { status: 200, data: '' });
            }
        }
        else {
            const params = {
                language: lng,
                namespace: ns,
            };
            getAggregatedTranslations({ params })
                .then(({ data }) => {
                const response = {
                    status: data.responseCode,
                    data: JSON.stringify(data.data[0]?.namespaces?.[0]?.values),
                };
                callback(null, response);
            })
                .catch((error) => callback(error, { status: unsafeCastToApiError(error, StatusSchema)?.response?.status || 500, data: '' }));
        }
    },
    reloadInterval: 1000 * 60 * 10,
};
export default backendOptions;
